import { render, staticRenderFns } from "./ContentNotificationReminderModal.vue?vue&type=template&id=9dc0873c&"
import script from "./ContentNotificationReminderModal.vue?vue&type=script&lang=js&"
export * from "./ContentNotificationReminderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports